import React from "react";
import SubMenu from "../../base/SubMenu";
import Start from "./Start";
import BFS from "./BFS";
import Downloads from "../base/Downloads";
import Ubersicht from "./Übersicht";

function Main(props) {

    const startRef = React.createRef()
    const ubersichtRef = React.createRef()
    const berufRef = React.createRef()
    const downloadsRef= React.createRef()

    return (
        <React.Fragment>
            <SubMenu model={{
                background: "#9FCFF2",
                items: [
                    { label: <strong>Berufsfachschule</strong>},
                    { label: "Start", onClick: () => window.location.href = "/bildungsangebote/berufsfachschule"},
                    { label: "BFS", onClick: () => startRef.current.scrollIntoView()},
                    { label: "Übersicht", onClick: () => ubersichtRef.current.scrollIntoView()},
                    { label: "Die Zweijährige Berufsfachschule (BFS)", onClick: () => berufRef.current.scrollIntoView()},
                    {label: "Downloads", onClick:()=> downloadsRef.current.scrollIntoView()}
                ]
            }}/>
            <div ref={startRef}><Start/></div>
            <div ref={ubersichtRef}><Ubersicht/></div>
            <div ref={berufRef}><BFS/></div>
            <div ref={downloadsRef} className="wrapper wrapperContent" style={{ color:" #488e62"}}>
                <Downloads
                    model={
                        {
                            items: [
                                {label: 'BFS Anmeldeformular', download: 'BFS Schulvertrag.pdf', url: '/assets/berufsfachschule/Schulvertrag_BFS_mai25.pdf'},
                                {label: 'BFS Verordnung über die Ausbildung und die Prüfung vom 02. Dezember 2011', download: 'BFS Verordnung über die Ausbildung und die Prüfung.pdf', url: '/assets/berufsfachschule/BFS Verordnung über die Ausbildung und die Prüfung.pdf'},
                                {label: 'BFS Vordruck Entschuldigungsschreiben',download: 'BFS Vordruck Entschuldigungsschreiben.pdf',url: '/assets/berufsfachschule/BFS Vordruck Entschuldigungsschreiben.pdf'},
                                {label: 'BFS Lehrplan Wirtschaft ',download: 'BFS Lehrplan Wirtschaft.pdf',url: '/assets/berufsfachschule/BFS Lehrplan Wirtschaft.pdf'}
                            ]
                        }
                    }/>
            </div>
        </React.Fragment>

    );
}

export default Main;
